import { createContext, useCallback, useContext } from 'react'
import { computeProfileCompletion } from '../utils/profileCompletion'
import { useMyProfile } from '../features/profile/useMyProfile'

interface ProfileCompletionContextValue {
  completion: number
  refresh: () => void
}

const ProfileCompletionContext = createContext<ProfileCompletionContextValue>({
  completion: 100,
  refresh: () => {},
})

export function useProfileCompletion() {
  return useContext(ProfileCompletionContext)
}

export function ProfileCompletionProvider({ children }: { children: React.ReactNode }) {
  // Reads the shared /my-profile cache — the dashboard reads the same entry, so
  // the two no longer each fetch it. Defaults to 100 (badge hidden) until loaded
  // or on error.
  const { profile, refresh: refreshProfile } = useMyProfile()
  const completion = profile ? computeProfileCompletion(profile) : 100

  const refresh = useCallback(() => void refreshProfile(), [refreshProfile])

  return (
    <ProfileCompletionContext.Provider value={{ completion, refresh }}>
      {children}
    </ProfileCompletionContext.Provider>
  )
}
